const TransformxWrapper = ({ children }) => (
  <div className="relative text-white bg-black">
    <div className="absolute z-0 w-screen h-screen max-w-full -top-48 bg-transform-x-page" />
    <div className="relative z-10 text-white">{children}</div>
  </div>
);

export default TransformxWrapper;
